export enum helloTypes {
  FETCH_HELLO_REQUEST = "FETCH_HELLO_REQUEST",
  FETCH_HELLO_SUCCESS = "FETCH_HELLO_SUCCESS",
  FETCH_HELLO_FAILURE = "FETCH_HELLO_FAILURE",
}